import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const AideServices = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Aide Services
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex max-w-fit'>
              <p className='text-black sm:text-justify md:text-xl'>
                Our aides work exclusively with your family to implement the
                goals set in place by your child’s therapy team. Aide service
                programs are 100% catered to the needs of the client and up to 7
                days of week of service can be implemented to teach, practice
                and reinforce Occupational Therapy, Speech Therapy and Behaviour
                Therapy goals and strategies. Both FSCD vendor direct pay and
                private pay options are available.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/aide.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AideServices;
